import "./table.css";
import { useEffect, useState } from 'react';
import axiosInstance from "../../../services/axios-instance";
import {
    All_USERS_URL,
    NATIONAL_HOLIDAYS_URL,
    HOLIDAYS_URL,
} from "../../../services/endpoints";
import { AllHolidaysInterface } from "../../../interface/allHolidaysInterface";
import { NationalHolidaysInterface } from "../../../interface/nationalHolidayInterface";
import { AllUsersInterface } from "../../../interface/allUsersInterface";
import {
    Box,
    Grid,
} from "@mui/material";
import { Circle } from "@mui/icons-material";

const TableReport = () => {

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const [users, setUsers] = useState<AllUsersInterface[]>([]);
    const [allHolidays, setAllHolidays] = useState<AllHolidaysInterface[]>([]);
    const [nationalHolidays, setNationalHolidays] = useState<
        NationalHolidaysInterface[]
    >([]);

    function getDaysInMonth() {
        const daysInMonth = [];
        const year = new Date().getFullYear();
        for (let month = 0; month < 12; month++) {
            const lastDay = new Date(year, month + 1, 0).getDate();
            daysInMonth.push(lastDay);
        }
    
        return daysInMonth;
    }

    function getClient(userId: number, date : Date) {
        const dateToCheck = formatDateToYYYYMMDD(date);
        const user = users.find(user => user.id === userId);
        const clients = user?.clients;
        let assignedClients = [];
        if (clients) {

            for (let i = 0; i < clients.length; i++) {
                const fromDate = new Date(clients[i]?.pivot.from_date);
                const toDate = new Date(clients[i]?.pivot.to_date);
                const checkDate = new Date(dateToCheck);
                if( checkDate >= fromDate && checkDate <= toDate){
                    assignedClients.push(clients[i].name);
                }
            }
        }

        return assignedClients;

    };

    function formatDateToYYYYMMDD(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
      
        return `${year}-${month}-${day}`;
      }

    function isNationalHoliday(date: Date) {
        const holiday = nationalHolidays.find((h) => h.date === formatDateToYYYYMMDD(date));
        return holiday !== undefined;
    };

    function isHoliday(date: Date, userId: number) {
        const dateToCheck = formatDateToYYYYMMDD(date);
        const targetList = allHolidays.filter(obj => obj.requesting_id == userId && obj.status == 1);
        return targetList.some((obj: any) => {
            const fromDate = new Date(obj.from_date);
            const toDate = new Date(obj.to_date);
            const checkDate = new Date(dateToCheck);
            return checkDate >= fromDate && checkDate <= toDate;
        });
    }

    function isPendingHoliday(date: Date, userId: number) {
        const dateToCheck = formatDateToYYYYMMDD(date);
        const targetList = allHolidays.filter(obj => obj.requesting_id == userId && obj.status == 0);
        return targetList.some((obj: any) => {
            const fromDate = new Date(obj.from_date);
            const toDate = new Date(obj.to_date);
            const checkDate = new Date(dateToCheck);
            return checkDate >= fromDate && checkDate <= toDate;
        });
    }

    useEffect(() => {
        const handleScroll = () => {
            const menu = document.querySelector<HTMLElement>('.openedMenu');
            const table = document.querySelector<HTMLElement>('.year-table-container');
            if (menu && table && window.scrollX > 100) {
                table.style.transform = 'translateX(170px)';
            }
            else if(table && window.scrollX == 0) {
                table.style.transform = 'translateX(0)';
            }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

      useEffect(() => {

        function mapClients() {
            const table = document.querySelector('.year-table');
            const colors = ["#DC143C","#4169E1","#32CD32","#FF1493", "#FFD700", "#40E0D0"];
            let clientColors : any = [];
            if (table) {
                const rows = table.querySelectorAll('tbody tr');
                if (rows.length == 0) {
                    setTimeout(mapClients, 500);
                }
                let clientsPerRow: string[][] = [];
                rows.forEach((row,index) => {
                    clientsPerRow[index] = [];
                    const cells = row.querySelectorAll('td');
                    let i = 0;
                    cells.forEach(cell => {
    
                        console.log(cell);
                        if(cell.hasAttribute('data-client') && (cell.getAttribute('data-client') != "")) {
                            const dataClient = cell.getAttribute('data-client') ?? '';
                            for (const item of dataClient.split(",")) {
                                if (clientsPerRow[index].indexOf(item) === -1) {
                                    clientsPerRow[index].push(item);
                                    clientColors.push({client: item, color: colors[i]})
                                    i++;
                                }
                            }
                            const cellClients = cell.getAttribute('data-client')?.split(",");
                            if (cellClients && cellClients.length > 0) {
                              let clientColorsArray = cellClients.map(clientName => 
                                clientColors.find((clientObj : any) => clientObj.client === clientName)
                              );
                          
                              if (clientColorsArray.length === 1) {
                                cell.style.background = clientColorsArray[0].color;
                              } else {
                                let numberOfColors = clientColorsArray.length;
                                let stopInterval = 100 / numberOfColors;
    
                                let gradientStops = clientColorsArray.map((client, index) => {
                                let startPosition = index * stopInterval;
                                let endPosition = startPosition + stopInterval;
                                return `${client.color} ${startPosition}%, ${client.color} ${endPosition}%`;
                                });
                          
                                cell.style.background = `linear-gradient(to bottom, ${gradientStops.join(", ")})`;
                              }
                            }
                        }
                    });
                });
            }
        }
        mapClients();
      }, []);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axiosInstance.get(All_USERS_URL);
                setUsers(response.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        async function fetchAllHolidaysData() {
            try {
                const responseAllHolidays = await axiosInstance.get(
                    HOLIDAYS_URL
                );
                setAllHolidays(responseAllHolidays.data.data);
            } catch (error) {
                console.error(error);
            }
        }

        const fetchNationalHolidays = async () => {
            try {
                const responseNatinalHolidays = await axiosInstance.get(
                    NATIONAL_HOLIDAYS_URL
                );
                setNationalHolidays(responseNatinalHolidays.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchUsers();
        fetchAllHolidaysData();
        fetchNationalHolidays();
    }, []);

  const generateDaysOfYear = () => {
    const days = [];
    const currentDate = new Date(new Date().getFullYear(), 0, 1);
    while (currentDate.getFullYear() === new Date().getFullYear()) {
      days.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return days;
  };

  const daysOfYear = generateDaysOfYear();

  return (
    <div className="year-table-container">
                <Grid 
                sx={{
                    width: "fit-content",
                    position: "sticky",
                    left: "4rem",
                    display: "block",
                }}
                item>
                    <Box
                        sx={{
                            display: "flex",
                            gap: 3,
                            justifyContent: "center",
                            msWrap: "wrap",
                            mt: {
                                xl: 2,
                            },
                        }}
                    >
                        <Box
                            component={"p"}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                    xs: "0.8rem",
                                    xl: "1rem",
                                },
                            }}
                        >
                            <Circle
                                sx={{
                                    paddingRight: "5px",
                                    "&.MuiSvgIcon-root": {
                                        color: "holiday.pending",
                                    },
                                }}
                            />
                            Pending
                        </Box>
                        <Box
                            component={"p"}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                    xs: "0.8rem",
                                    xl: "1rem",
                                },
                            }}
                        >
                            <Circle
                                sx={{
                                    paddingRight: "5px",
                                    "&.MuiSvgIcon-root": {
                                        color: "holiday.approved",
                                    },
                                }}
                            />
                            Approved
                        </Box>
                        <Box
                            component={"p"}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                    xs: "0.8rem",
                                    xl: "1rem",
                                },
                            }}
                        >
                            <Circle
                                sx={{
                                    paddingRight: "5px",
                                    "&.MuiSvgIcon-root": {
                                        color: "holiday.sickLeave",
                                    },
                                }}
                            />
                            Sick Leave
                        </Box>
                        <Box
                            component={"p"}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: {
                                    xs: "0.8rem",
                                    xl: "1rem",
                                },
                            }}
                        >
                            <Circle
                                sx={{
                                    paddingRight: "5px",
                                    "&.MuiSvgIcon-root": {
                                        color: "holiday.national",
                                    },
                                }}
                            />
                            National Holiday
                        </Box>
                    </Box>
                </Grid>
      <table className="year-table">
        <thead>
        <tr>
            <th className="firstCol" rowSpan={2} >{new Date().getFullYear()}</th>
            {months.map((month, index) => (
              <th colSpan={getDaysInMonth()[index]}>
                {month}
              </th>
            ))}
          </tr>
          <tr>
            {daysOfYear.map((day, index) => (
              <th 
              className="weekdayName"
              data-weekday={day.getDay()} 
              key={index}
              data-natholiday={isNationalHoliday(day)}>
                {day.toLocaleDateString(undefined, { weekday: 'short' })}
              </th>
            ))}
          </tr>
          <tr>
          <th className="firstCol" >XGate Team</th>
            {daysOfYear.map((day, index) => (
              <th 
              data-weekday={day.getDay()} 
              key={index}
              data-natholiday={isNationalHoliday(day)}>
                {day.toLocaleDateString('en-US', { day: 'numeric' })}
               </th>
            ))}
          </tr>
        </thead>
        <tbody>
            {users.map((user, index) => (
            <>
            <tr>
              <td 
              style= {{ borderTop: "5px solid gray", borderBottom: "5px solid gray"}}
              className="firstCol" rowSpan={2} key={index}>{user.name}</td>
              {daysOfYear.map((day, index) => (
                <td 
                style= {{ borderTop: "5px solid gray"}}
                key={index} 
                data-weekday={day.getDay()}
                data-natholiday={isNationalHoliday(day)}
                data-holiday={isHoliday(day,user.id)}
                data-pending={isPendingHoliday(day,user.id)}>
                    {(isNationalHoliday(day) || isHoliday(day,user.id)) && day.getDay() !=0 && day.getDay() != 6 ? "1" : ""}
                </td>
            ))}
            </tr>
            <tr>
              {daysOfYear.map((day, index) => (
                <td 
                style={getClient(user.id, day).toString() != "" ? {border: "none"} : { borderBottom: "5px solid gray"}}
                key={index}
                data-weekday={day.getDay()}
                title={getClient(user.id, day).toString()}
                data-natholiday={isNationalHoliday(day)}
                data-client={getClient(user.id, day)}>
                    {index === daysOfYear.length - 1 ? "." : ""}
                </td>
            ))}
            </tr>
            </>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableReport;
